// External libraries
import React from 'react';
//@ts-expect-error TODO untyped module
import { ErrorIcon, FullName } from '@checkout/react-components';

// Internal Modules
// @ts-expect-error TODO untyped import
import { ErrorContainer, ErrorMessage } from './../StyledComponents';
import { getContent } from '@/lib';
import { CRS_FIRST_NAME_ID, CRS_LAST_NAME_ID } from './../constants';
import { crsLegalNamesChangeHandler } from './handlers';
import { logCrsFieldEvents } from '../fpti';
import { Paragraph } from '../../Common';
import type { CRSEventDispatcher } from '../types';
import type { DefaultInputState } from '@/store';

interface CRSLegalNamesProps {
  crsLegalNames: {
    crsLegalFirstName: DefaultInputState;
    crsLegalLastName: DefaultInputState;
  };
  dispatch: CRSEventDispatcher;
}

export const CRSLegalNames = ({
  crsLegalNames,
  dispatch,
}: CRSLegalNamesProps): React.ReactElement => {
  const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) =>
    crsLegalNamesChangeHandler(event, dispatch, crsLegalNames);

  const { crsLegalFirstName: firstName, crsLegalLastName: lastName } =
    crsLegalNames;

  return (
    <>
      <Paragraph margin={'0 0 24px 0'}>
        {getContent('crs.declaration')}
      </Paragraph>
      <FullName
        blurHandler={logCrsFieldEvents}
        changeHandler={changeHandler}
        firstName={firstName}
        firstNameId={CRS_FIRST_NAME_ID}
        focusHandler={logCrsFieldEvents}
        labels={{
          firstName: getContent('crs.fieldLabels.firstName'),
          lastName: getContent('crs.fieldLabels.lastName'),
        }}
        lastName={lastName}
        lastNameId={CRS_LAST_NAME_ID}
      />

      {(firstName.displayError || lastName.displayError) && (
        <ErrorContainer data-testid="error-container">
          <ErrorIcon />
          <ErrorMessage data-testid="legal-names-error">
            {getContent('crs.errors.legalFullName')}
          </ErrorMessage>
        </ErrorContainer>
      )}
    </>
  );
};
